import { IGetTermoByIdUseCase } from "../../../presentation/useCases/read/get_termo_by_id_use_case";
import { Termo } from "../../models/termo";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * GetTermoByIdUseCase
 */

export class GetTermoByIdUseCase implements IGetTermoByIdUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(idTermo: number): Promise<Termo> {
    return this.repository.getTermoById(idTermo);

  }

}
